import { Shark, SmartModel } from "shark-mvc";
// import moment from "moment";

import docIcon from "../images/icons/doc-big.png";
import dwgIcon from "../images/icons/dwg-big.png";
import fileIcon from "../images/icons/file-big.png";
import mpgIcon from "../images/icons/mpg-big.png";
import pdfIcon from "../images/icons/pdf-big.png";
import pptIcon from "../images/icons/ppt-big.png";
import tiffIcon from "../images/icons/tiff-big.png";
import txtIcon from "../images/icons/txt-big.png";
import xlsIcon from "../images/icons/xls-big.png";
import zipIcon from "../images/icons/zip-big.png";

class Document extends SmartModel {
	static STATUS_EXPIRED = 8;

	constructor(data) {
		super();

		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.extraData = {
			lotId: -1,
		};
		this.fileType = "";
		this.fileURL = "";
		this.fileSize = 0;
		this.folderGuid = "";
		this.guid = "";
		this.name = "";
		this.referencePeriod = "";
		this.referenceProductLinesGuids = [];
		this.revision = "";
		this.role = "";
		this.section = "";
		this.source = "";
		this.status = 0;// 8: Vecchia versione|scaduto, 9: cancellato
		this.tags = [];
		this.title = "";
		this.thumbnailURL = "";
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";
			
		this.__hasFileURL = false;
		this.__fallBackThumbnailURL = "";
		this.__fileSize = "";
		this.__roleLabel = "";
		this.__selected = false;
		this.__sourceLabel = "";
		this.__tags = "";

		if (data) {
			this.import(data);
		}
	}

	export (mode) {
		let exportData;

		switch (mode) {
			case "attachmentPreview":
				exportData = {
					fileSize: this.__fileSize,
					fileType: this.fileType,
					fileURL: this.fileURL,
					guid: this.guid,
					name: this.name,
					thumbnailURL: this.thumbnailURL,
				};
				break;
			default:
				exportData = this.__export();
				exportData.extraData = this.exportObjectField("extraData");
				exportData.referenceProductLinesGuids = this.exportArrayField("referenceProductLinesGuids");
				exportData.tags = this.exportArrayField("tags");
				break;
		}

		return exportData;
	}

	import (data, options) {
		this.__import(data, options);
		
		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAtLabel = this.createdAt.format("DD/MM/YYYY");
		}
		
		this.importNumberField("fileSize", data.fileSize);
		this.importNumberField("status", data.status);

		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format("YYYY-MM-DD");
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YYYY - HH:mm");
		}

		this.parseFileSize();

		if (this.thumbnailURL === "" || this.thumbnailURL === this.fileURL) {
			switch (this.fileType.toLowerCase()) {
				case "jpg":
				case "jpeg":
					this.thumbnailURL = "/" + this.fileURL.replace(".jpg", "_tmb.jpg");
					this.__fallBackThumbnailURL = this.fileURL;
					break;
				case "pdf":
					this.thumbnailURL = "/" + pdfIcon;
					break;
				case "doc":
				case "docx":
					this.thumbnailURL = "/" + docIcon;
					break;
				case "dwg":
					this.thumbnailURL = "/" + dwgIcon;
					break;
				case "mp4":
				case "mpg":
					this.thumbnailURL = "/" + mpgIcon;
					break;
				case "ppt":
				case "pptx":
					this.thumbnailURL = "/" + pptIcon;
					break;
				case "tif":
				case "tiff":
					this.thumbnailURL = "/" + tiffIcon;
					break;
				case "txt":
					this.thumbnailURL = "/" + txtIcon;
					break;
				case "xls":
				case "xlsx":
					this.thumbnailURL = "/" + xlsIcon;
					break;
				case "zip":
					this.thumbnailURL = "/" + zipIcon;
					break;
				default:
					this.thumbnailURL = "/" + fileIcon;
					break;
			}
		}

		if (["jpg", "jpeg", "png"].indexOf(this.fileType) > -1) {
			this.__enableLightBox = true;
		}

		this.__hasFileURL = this.fileURL !== "";
		this.__hasThumbnailURL = this.thumbnailURL !== "";
		if (Array.isArray(this.tags)) {
			this.__tags = this.tags.join(",");
		}

		//Dave: Ma non dovrei fare in modo che l'import chiami il set di ogni valore??
		this.parseRole();
		this.parseSource();
		this.parseStatus();

		console.log(this);
	}

	onDataChanged(data) {
		switch (data.property) {
			case "fileURL":
				this.__hasFileURL = this.fileURL !== "";
				break;
			case "thumbnailURL":
				this.__hasThumbnailURL = this.thumbnailURL !== "";
				break;
			case "fileSize":
				this.parseFileSize();
				break;
			case "__tags":
				this.tags = data.newValue.split(",").map(item => item.trim());
				break;
		}
	}

	onRoleChanged () {
		this.parseRole();
	}

	onStatusChanged () {
		this.parseStatus();
	}

	parseFileSize () {
		let mbValue = this.fileSize / Math.pow(1024, 2);
		if (this.fileSize < 102400) {
			this.__fileSize = mbValue.toFixed(2);
		}
		else {
			this.__fileSize = mbValue.toFixed(1);
		}
	}

	parseRole () {
		switch (this.role) {
			case "constructionSiteWorksheet":
				this.__roleLabel = "Foglio Lavoro Cantiere";
				break;
			case "fiscalClosingDocument":
				this.__roleLabel = "Documento di Chiusura Fiscale";

				if (this.extraData?.lotId !== undefined && this.extraData?.lotId > -1) {
					this.__roleLabel += " Lotto #" + (this.extraData?.lotId + 1);
				}
				break;
		}
	}

	parseSource () {
		switch (this.source) {
			case "constructionSiteCard":
				this.__sourceLabel = "Scheda Cantiere";

				if (this.extraData?.lotId !== undefined && this.extraData?.lotId > -1) {
					this.__sourceLabel += " Lotto #" + (this.extraData?.lotId + 1);
				}
				break;
			case "notComplianceReportCause":
				this.__sourceLabel = "Non Conformità (causa)";
				break;
			case "notComplianceReportWarranty":
				this.__sourceLabel = "Non Conformità (garanzia)";
				break;
			case "siteInfoSheet":
				this.__sourceLabel = "Scheda Informativa";
				break;
		}
	}

	parseStatus() {
		this.__status_expired = this.status === Document.STATUS_EXPIRED;
	}
}

Shark.registerModel("Document", Document);

export default Document;